export const TIPO_DATOS_FISCALES = {
  EMPRESA: 'EMPRESA',
  AUTONOMO: 'AUTONOMO',
  PARTICULAR: 'PARTICULAR',
};

export const LETRAS_DOCUMENTO_ESPANOL = 'TRWAGMYFPDXBNJZSQVHLCKE';
export const LETRAS_CIF_SOLO_NUMERO = 'ABEH';
export const LETRAS_CIF_SOLO_LETRA = 'PQSW';
